// import Home from './components/Home'
import UserLogIn from './components/UserLogin'
import UserJoin from './components/UserJoin'
import UserReset from './components/UserReset'

import Home from './components/Home'

// import AddPhoto from './components/AddPhoto'
// import Upload from './components/Upload'
import ImageUpload from './components/ImageUpload'

const routes = [
  { path: '/', component: UserLogIn },
  { path: '/login', component: UserLogIn },
  { path: '/signin', component: UserLogIn },
  { path: '/signup', component: UserJoin },
  { path: '/join', component: UserJoin },
  { path: '/reset', component: UserReset },
  { path: '/post/:id', component: ImageUpload },
  { path: '/home', component: Home }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js